import { createContext, useState } from "react";
import sun from "../assets/images/header/Sun.png";
import moon from "../assets/images/header/Moon.png";
import "../i18n";
//  ***** React i18next ****** //
import { useTranslation } from "react-i18next";
export const LangContext = createContext({
  image: "",
  textMode: "",
  isOpen: "",
  setTextMode: () => {},
  setImage: () => {},
  loadLang: () => {},
  lightMode: () => {},
  darkMode: () => {},
  setIsOpen: () => {},
});
export const LangCondecriptionrovider = (props) => {
    const { t } = useTranslation();
    const [image, setImage] = useState();
  const [textMode, setTextMode] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const loadLang = () => {
    const allP = document.getElementsByTagName("p");
    const alla = document.getElementsByTagName("div");
    const langStorage = localStorage.getItem("language");
    if (langStorage === "fa" || langStorage === "ar") {
      for (let i = 0; i < allP.length; i++) {
        allP[i].classList.add("text-end");
        allP[i].classList.remove("text-start");
      }
      for (let i = 0; i < alla.length; i++) {
        alla[i].classList.add("text-end");
        alla[i].classList.remove("text-start");
      }
      document.dir = "rtl";
    } else {
      for (let i = 0; i < allP.length; i++) {
        allP[i].classList.add("text-start");
        allP[i].classList.remove("text-end");
      }
      for (let i = 0; i < alla.length; i++) {
        alla[i].classList.add("text-start");
        alla[i].classList.remove("text-end");
      }

      document.dir = "ltr";
    }
  };

  function darkMode() {
    let myBody = document.querySelector("body");
    myBody.classList.add("dark");
    setImage(sun);
    setTextMode(t("darkMode"));
  }

  function lightMode() {
    let myBody = document.querySelector("body");
    myBody.classList.remove("dark");
    setImage(moon);
    setTextMode(t("lightMode"));
 
  }

  const contextValue = {
    image,
    setImage,
    textMode,
    setTextMode,
    loadLang,
    lightMode,
    darkMode,
    isOpen,
    setIsOpen,
  };
  return (
    <LangContext.Provider value={contextValue}>
      {" "}
      {props.children}{" "}
    </LangContext.Provider>
  );
};
